import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Divider, Grid, Button } from '@material-ui/core';

import CommandModal from './CommandModal';
import CommandPv1Gprs from './CommandPv1Gprs';
import CommandPv2Gprs from './CommandPv2Gprs';
import CommandPv1Admin from './CommandPv1Admin';
import CommandPv2Admin from './CommandPv2Admin';

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  sectionDivider: {
    marginBottom: theme.spacing(2),
  },
  sendCommandBtn: {
    fontWeight: 600,
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 15,
    paddingBottom: 15,
  },
}));

const CommandsUnifiedModal = (props) => {
  const { lastEvent, lastEventEquipment, showStatus, setIsVisible } = props;
  const classes = useStyles();
  const [showModal, setShowModal] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const gprsSubmitRef = useRef(null);
  const adminSubmitRef = useRef(null);
  const gprsDirtyRef = useRef(false);
  const adminDirtyRef = useRef(false);

  // When the equipment is linked to a lock, `lastEvent` is overwritten by the
  // lock-event (with `status: {}`), so the real toggles/protocol of the
  // equipment live in `lastEventEquipment`. Prefer it when available so the
  // command modal reflects the actual equipment state.
  const effectiveEvent = (lastEventEquipment && Object.keys(lastEventEquipment).length > 0)
    ? lastEventEquipment
    : lastEvent;

  const protocolVersion = (effectiveEvent && effectiveEvent.protocolVersion) || 'V2';

  const handleClose = () => {
    setShowModal(false);
    if (setIsVisible) {
      setIsVisible(false);
    }
  };

  const sharedProps = {
    showStatus,
    setIsVisible: () => {},
    renderAsContent: true,
    ...(effectiveEvent || {}),
  };

  const handleSubmitAll = async () => {
    if (submitting) return;

    const hasGprsChanges = gprsDirtyRef.current && gprsSubmitRef.current;
    const hasAdminChanges = adminDirtyRef.current && adminSubmitRef.current;

    if (!hasGprsChanges && !hasAdminChanges) {
      handleClose();
      return;
    }

    setSubmitting(true);
    let cancelled = false;
    try {
      if (hasGprsChanges) {
        const gprsResult = await gprsSubmitRef.current();
        if (gprsResult && gprsResult.cancelled) {
          cancelled = true;
          return;
        }
      }
      if (hasAdminChanges) {
        await adminSubmitRef.current();
      }
    } finally {
      setSubmitting(false);
      if (!cancelled) {
        handleClose();
      }
    }
  };

  const markGprsDirty = () => {
    gprsDirtyRef.current = true;
  };
  const markAdminDirty = () => {
    adminDirtyRef.current = true;
  };

  return (
    <CommandModal
      isOpen={showModal}
      onClose={handleClose}
      title="Comandos"
    >
      <Typography className={classes.sectionHeader}>GPRS</Typography>
      <Divider className={classes.sectionDivider} />
      <div onChangeCapture={markGprsDirty}>
        {protocolVersion === 'V2'
          ? <CommandPv2Gprs {...sharedProps} submitRef={gprsSubmitRef} />
          : <CommandPv1Gprs {...sharedProps} submitRef={gprsSubmitRef} />}
      </div>

      <Typography className={classes.sectionHeader} style={{ marginTop: 32 }}>
        Administrativos
      </Typography>
      <Divider className={classes.sectionDivider} />
      <div onChangeCapture={markAdminDirty}>
        {protocolVersion === 'V2'
          ? <CommandPv2Admin {...sharedProps} submitRef={adminSubmitRef} />
          : <CommandPv1Admin {...sharedProps} submitRef={adminSubmitRef} />}
      </div>

      <Grid container direction="row" justify="flex-end" style={{ marginTop: 32, marginBottom: 16 }}>
        <Button
          variant="contained"
          color="primary"
          className={classes.sendCommandBtn}
          onClick={handleSubmitAll}
          disabled={submitting}
        >
          {submitting ? 'Enviando...' : 'Enviar comando'}
        </Button>
      </Grid>
    </CommandModal>
  );
};

export default CommandsUnifiedModal;
